__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_78_0a3cae16/_next/";